import { render, staticRenderFns } from "./PasswordResetOtp.vue?vue&type=template&id=387f4e41&scoped=true"
import script from "./PasswordResetOtp.vue?vue&type=script&lang=js"
export * from "./PasswordResetOtp.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetOtp.vue?vue&type=style&index=0&id=387f4e41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f4e41",
  null
  
)

export default component.exports